module.exports = __webpack_public_path__ + "909af23f484db97f4a617bebd2f2fd80.png";